import Vue from 'vue'

import Vuelidate from 'vuelidate'
Vue.use(Vuelidate)

import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
Vue.component('v-select-c', vSelect)

import Toasted from 'vue-toasted'
Vue.use(Toasted)

var numeral = require('numeral')
Vue.prototype.$formatCurrency = value => {
    return numeral(value).format('0,0').replace(/,/g, '.')
}

Vue.component(
    'reserve-form',
    require('../../js/components/projects/ReserveForm.vue').default
)

Vue.config.productionTip = false
Vue.config.devtools = false

if (document.getElementById('vue-reserve-form')) {
    new Vue({
        el: '#vue-reserve-form'
    })
}
